import { Svg, utils } from '@costar/theme-ui';
import React from 'react';
import { DefaultContext, IconContext } from './icon-context';
export const IconPrivate = React.forwardRef(function IconPrivate(props, ref) {
  const identifier = utils.useUniqueId('icon');
  const elem = conf => {
    const {
      attr,
      size: sizeProp,
      title,
      glowEffect,
      color: colorProp,
      style: styleProp = utils.EMPTY_OBJECT,
      children,
      ...svgProps
    } = props;
    const {
      color: colorConf,
      size: sizeConf,
      style: styleConf = utils.EMPTY_OBJECT
    } = conf || utils.EMPTY_OBJECT;
    const color = colorProp || colorConf;
    const size = sizeProp || sizeConf || '1em';
    // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
    const style = {
      ...styleConf,
      ...styleProp
    };
    return React.createElement(Svg, {
      ref: ref,
      ...attr,
      className: "csg-tui-icon-svg",
      style: !utils.isEmptyObject(style) ? style : undefined,
      height: size,
      width: size,
      color,
      ...svgProps
    }, title && React.createElement("title", null, title), glowEffect ? React.createElement(React.Fragment, null, React.createElement("defs", null, React.createElement("filter", {
      id: `glow-${identifier}`
    }, React.createElement("feGaussianBlur", {
      in: "SourceAlpha",
      stdDeviation: "1.2"
    }), React.createElement("feOffset", {
      dx: "0",
      dy: "0",
      result: "offsetblur"
    }), React.createElement("feComponentTransfer", null, React.createElement("feFuncA", {
      type: "linear",
      slope: "0.5"
    })), React.createElement("feMerge", null, React.createElement("feMergeNode", null), React.createElement("feMergeNode", {
      in: "SourceGraphic"
    })))), React.createElement("g", {
      filter: `url(#glow-${identifier})`
    }, children)) :
    // eslint-disable-next-line react/jsx-no-useless-fragment
    React.createElement(React.Fragment, null, children));
  };
  return IconContext !== undefined ? React.createElement(IconContext.Consumer, null, conf => elem(conf)) : elem(DefaultContext);
});
function Tree2Element(tree) {
  return tree && tree.map((node, i) => React.createElement(node.tag, {
    key: i,
    ...node.attr
  }, Tree2Element(node.child)));
}
export function GenIcon(data) {
  return function Icon(props) {
    const {
      attr
    } = data ?? {};
    return React.createElement(IconPrivate, {
      attr: attr,
      ...props
    }, Tree2Element(data.child));
  };
}